import { Sparkles } from "lucide-react";

export default function Header() {
  return (
    <header
      data-testid="app-header"
      className="relative overflow-hidden border-b border-border bg-sand-50 no-print"
    >
      {/* Decorative motif overlay (very low opacity) */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.07] bg-motif"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-clay/10 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-12 -bottom-16 h-56 w-56 rounded-full bg-moss/10 blur-3xl"
      />

      <div className="relative mx-auto flex max-w-7xl flex-col gap-6 px-4 py-10 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="flex items-start gap-5">
          <div
            aria-hidden
            className="hidden h-16 w-16 shrink-0 items-center justify-center rounded-xl border border-border bg-white text-clay shadow-sm sm:flex"
          >
            <Sparkles className="h-7 w-7" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-ink-700">
              Independent SaaS · Documentation Assistance Platform
            </p>
            <h1 className="mt-3 max-w-3xl font-heading text-4xl font-semibold tracking-tight text-ink-900 sm:text-5xl">
              Quarterly UC &amp; Hand Receipt Generator
            </h1>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink-700">
              Enter your school's monthly meal, fund and ingredient data once — auto-generate structured
              quarterly report formats instantly. OGFR-23, OGFR-24, Annexure-1, Hand Receipts (Odia),
              Ingredient-wise statements and more — for productivity and convenience purposes.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
